<template>
  <div>
    <Detail :props-obj="propsObj" />
  </div>
</template>
<script>
import Detail from './detail';
export default {
  name: 'FamousTeaSpecialareaDetail',
  components: {
    Detail
  },
  data: () => {
    return {
      propsObj: {
        link: 'moduleResult'
      }
    };
  },
  computed: {
  },
  watch: {
    $route: {
      handler: function(route) {
        this.propsObj.propsId = route.params.id;
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
  }
};
</script>
